import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
/* eslint-disable import/no-cycle */
/* eslint-disable no-nested-ternary */
import React, { useEffect, useState } from "react";
import { apiGetRDModal, apiAcceptPriceIncrease, } from "Root/api/apiProfile";
import NavBar from "ProfileComponents/Navigation/NavBar";
import { useDispatch, useSelector } from "react-redux";
import { LoadUserCartThunk } from "Root/profile/redux/thunkCreators/products/userCart";
import { setGlobalLoading, setHomeStoreAction, } from "Root/profile/redux/actionCreators/makeActionCreator";
import { useHistory } from "react-router";
import HandWithShaker from "Images/profile/hand_with_shaker.png";
import { useTracking } from "react-tracking";
import { RDModal } from "Root/profile/utils/trackingEnums";
import styles from "./style.module.css";
import AccountOrderStatus from "./AccountOrderStatus/index";
import AccountSubscriptionSection from "./AccountSubscriptionSection/index";
import AccountBanner from "./AccountBanner/index";
import AccountRDSection from "./AccountRDSection/index";
import AccountProductUpsell from "./AccountProductUpsell/index";
import FirstSessionModal from "../common/FirstSessionModal";
import PriceUpdateScreen from "./PriceUpdateScreen/index";
import MissHeader from "../ReactivateSubscription/Home/WeMissHeader/missHeader";
import ReactivateEdit from "../ReactivateSubscription/ReactivateEdit";
import FutureModal from "./FutureModal";
import AccountGetStartedSection from "./AccountGetStartedSection";
import { fetchUserAccountThunk } from "Root/profile/redux/thunkCreators/accountSettings/accountSettingsThunk";
import Loading from "Components/Loading";
import posthog from "posthog-js";
import PromoCard from "./PromoCard";
import FutureTile from "./FutureTile";
const AccountOverview = () => {
    const reduxStoreIsEmpty = useSelector((state) => state.checkStore.home);
    const [isFirstSession, setIsFirstSession] = useState(false);
    const [showGreensModal, setShowGreensModal] = useState(false);
    const [showPriceSplashScreen, setShowPriceSplashScreen] = useState(false);
    const history = useHistory();
    const { nav_visibility, loading } = useSelector((state) => state.components);
    const dispatch = useDispatch();
    const user = useSelector((state) => state.user);
    const tier = useSelector((state) => state.accountSettings.userAccount.tier);
    const ordersInfo = useSelector((state) => state.ordersInfo);
    const [newPrice, setNewPrice] = useState("$65");
    const [isOpenReactivation, setIsOpenReactivation] = useState(false);
    const [showFutureModal, setShowFutureModal] = useState(false);
    const toggleReactivation = (value) => () => {
        setIsOpenReactivation(value);
    };
    const handleReactivate = () => {
        if (user.is_influencer) {
            history.push("/app/settings#paymentMethod");
        }
        else {
            setIsOpenReactivation(true);
        }
    };
    const { trackEvent } = useTracking();
    const trackRDModalClosed = () => {
        trackEvent({
            funComponent: RDModal.RD_welcome_modal,
            event: `${RDModal.RD_welcome_modal_closed}`,
        });
    };
    const trackRDModalLoaded = () => {
        trackEvent({
            funComponent: RDModal.RD_welcome_modal,
            event: `${RDModal.RD_welcome_modal_shown}`,
        });
    };
    const goToHowToLp = () => history.push("/app/howtolp");
    const acceptNewPrices = () => {
        apiAcceptPriceIncrease();
        setShowPriceSplashScreen(false);
    };
    const toggleModal = (value) => () => {
        if (!value) {
            trackRDModalClosed();
        }
        setIsFirstSession(value);
    };
    const fetchAllData = async () => {
        dispatch(setGlobalLoading(true));
        await Promise.all([
            dispatch(LoadUserCartThunk()),
            dispatch(fetchUserAccountThunk()),
        ]);
        // const results = await apiGetGreensModal();
        // setShowGreensModal(results ? results.show_banner : false);
        // setShowGreensModal(true);
        const rd_data = await apiGetRDModal(window.location.search);
        if (rd_data.banner === "rd_intro_modal" && rd_data.show_banner) {
            trackRDModalLoaded();
            setIsFirstSession(true);
        }
        else if (rd_data.banner === "new_plan_optin" && rd_data.show_banner) {
            setShowPriceSplashScreen(true);
            if (rd_data.extra_data && rd_data.extra_data.new_price) {
                setNewPrice(rd_data.extra_data.new_price);
            }
        }
        else if (rd_data.banner === "future_modal" && rd_data.show_banner) {
            const shownFutureModal = window.localStorage.getItem("__FM");
            if (!shownFutureModal) {
                setShowFutureModal("light");
            }
        }
        dispatch(setGlobalLoading(false));
    };
    useEffect(() => {
        window.scrollTo(0, 0);
        if (reduxStoreIsEmpty) {
            fetchAllData();
            dispatch(setHomeStoreAction(false));
        }
    }, []);
    const closeModal = () => {
        posthog?.capture("future_modal_closed", {});
        setShowFutureModal(false);
        window.localStorage.setItem("__FM", "true");
    };
    const isByb = user.user_class === "byb";
    return (_jsxs(_Fragment, { children: [nav_visibility && (_jsx(NavBar, { userName: user.full_name, showTop: true, userLoggedIn: true, hasSubscription: user.has_subscription, bannerData: user.banner_data })), showGreensModal && _jsx(PromoCard, {}), showFutureModal !== false && _jsx(FutureModal, { closeModal: closeModal }), _jsxs("div", { className: styles.account_page, children: [user.has_subscription ? (_jsxs(_Fragment, { children: [isFirstSession && (_jsx(FirstSessionModal, { openDrawer: isFirstSession, toggleDrawer: toggleModal })), showPriceSplashScreen && (_jsx(PriceUpdateScreen, { newPrice: newPrice, accept: acceptNewPrices })), !loading && tier ? (_jsx("div", { className: styles.order_status_row, children: _jsx(AccountOrderStatus, { ...ordersInfo.orderStatusData }) })) : (_jsxs("div", { className: styles.order_status_row, children: [_jsx(Loading, {}), _jsx(Loading, {})] })), _jsx(AccountGetStartedSection, {}), !loading && _jsx(AccountSubscriptionSection, {})] })) : (_jsxs(_Fragment, { children: [_jsx(MissHeader, { handleReactivate: handleReactivate }), _jsx("div", { className: styles.spacer }), _jsx(ReactivateEdit, { toggleReactivateDrawer: toggleReactivation, openReactivateDrawer: isOpenReactivation })] })), _jsx(FutureTile, {}), !isByb && _jsx(AccountProductUpsell, {}), _jsxs("div", { className: styles.banners_wrapper, children: [_jsx(AccountBanner, { imgUrl: HandWithShaker, title: "Product Use Guide", subtitle: "a guide to your system", text: "Learn how and when to consume your Gainful products. Check out your personalized Product Use Guide.", showButton: true, onClick: goToHowToLp, btnText: "View Guide" }), _jsx(AccountRDSection, {})] })] })] }));
};
export default AccountOverview;
